/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum QuoteStatus {
  Viewed = '-2',
  Expired = '-1',
  Draft = '1',
  Sent = '2',
  Approved = '3',
  Converted = '4',
  Rejected = '5',
}
